import React, { useState } from "react";
import Tabs from "./Tabs";
import Table from "./Table";
import Pagination from "./Pagination";
import Modal from "./Modal";

const Recce = () => {
  const [activeTab, setActiveTab] = useState("Received");
  const [currentPage, setPage] = useState(1);
  const rowsPerPage = 5; // Define rows per page
  const [selectedData, setSelectedData] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState([
    {
      signageID: "1",
      signageType: "FrontSide",
      height: "8feet",
      width: "5feet",
      reccepdf: "Na",
      adminStatus: "PENDING",
      clientStatus: "NOT SENT",
      ipName: "IP Name",
      creationDate: "04/11/2024",
      approveBy: "",
      approvalDate: "",
    },
    {
      signageID: "2",
      signageType: "BackSide",
      height: "6feet",
      width: "4feet",
      reccepdf: "Na",
      adminStatus: "APPROVED",
      clientStatus: "SENT",
      ipName: "Another IP",
      creationDate: "05/11/2024",
      approveBy: "Admin",
      approvalDate: "06/11/2024",
    },
  ]);

  // Filter data based on the active tab
  const filteredData = data.filter((item) => {
    if (activeTab === "Received")
      return item.clientStatus === "NOT SENT" || item.clientStatus === "SENT";
    if (activeTab === "Sent") return item.clientStatus === "SENT";
    return true;
  });

  // Pagination logic
  const paginatedData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  // Modal view handler
  const handleView = (row) => {
    setSelectedData(row);
    setModalOpen(true);
  };

  // Approve handler
  const handleApprove = (row) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.signageID === row.signageID
          ? { ...item, adminStatus: "APPROVED" }
          : item
      )
    );
    setModalOpen(false); // Close modal
  };

  // Client approve handler
  const handleClientApprove = (row) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.signageID === row.signageID
          ? { ...item, adminStatus: "APPROVED", clientStatus: "SENT" }
          : item
      )
    );
    setModalOpen(false); // Close modal
  };

  // Reject handler
  const handleReject = (row) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.signageID === row.signageID
          ? { ...item, adminStatus: "REJECTED" }
          : item
      )
    );
    setModalOpen(false); // Close modal
  };

  return (
    <div className="p-4">
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab} />
      <div className="mt-4">
        {activeTab && (
          <>
            <Table data={paginatedData} onView={handleView} />
            <Pagination
              currentPage={currentPage}
              totalPages={Math.ceil(filteredData.length / rowsPerPage)}
              setPage={setPage}
            />
          </>
        )}
      </div>
      {isModalOpen && selectedData && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
          data={selectedData}
          onApprove={handleApprove}
          onClientApprove={handleClientApprove}
          onReject={handleReject}
        />
      )}
    </div>
  );
};

export default Recce;
